import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'caas',
});

export const clusterOrderRef = createSubRouteRef({
  id: 'caas.order',
  parent: rootRouteRef,
  path: '/order',
});

export const clusterOrderSuccessRef = createSubRouteRef({
  id: 'caas.order.success',
  parent: rootRouteRef,
  path: '/order/success',
});

export const adminToolsRef = createSubRouteRef({
  id: 'caas.adminTools',
  parent: rootRouteRef,
  path: '/admin-tools',
});

export const clusterDetailRef = createSubRouteRef({
  id: 'caas.cluster.detail',
  parent: rootRouteRef,
  path: '/cluster/:clusterId',
});

export const clusterDetailsRef = createSubRouteRef({
  id: 'caas.cluster.details',
  parent: rootRouteRef,
  path: '/cluster/:clusterId/details',
});

export const clusterAddonsRef = createSubRouteRef({
  id: 'caas.cluster.addons',
  parent: rootRouteRef,
  path: '/cluster/:clusterId/addons',
});

export const clusterAuditLogRef = createSubRouteRef({
  id: 'caas.cluster.auditLog',
  parent: rootRouteRef,
  path: '/cluster/:clusterId/auditLog',
});
export const clusterInspectorRef = createSubRouteRef({
  id: 'caas.cluster.inspector',
  parent: rootRouteRef,
  path: '/cluster/:clusterId/inspector',
});
export const clusterPermissionsRef = createSubRouteRef({
  id: 'caas.cluster.permissions',
  parent: rootRouteRef,
  path: '/cluster/:clusterId/permissions',
});
export const clusterReleaseCenterRef = createSubRouteRef({
  id: 'caas.cluster.releaseCenter',
  parent: rootRouteRef,
  path: '/cluster/:clusterId/releaseCenter',
});
export const clusterSettingsRef = createSubRouteRef({
  id: 'caas.cluster.settings',
  parent: rootRouteRef,
  path: '/cluster/:clusterId/settings',
});
